import { render } from "./BakeryAppTwo.vue?vue&type=template&id=c195de0a"
import script from "./BakeryAppTwo.vue?vue&type=script&lang=js"
export * from "./BakeryAppTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__